import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import api from '../api';
import DataTable from '../components/DataTable';

const YAP_TURU = ['IDARI_PARA_CEZASI','GECICI_KAPATMA','KALICI_KAPATMA','IHTAR','MUHUR_FEKKI'];

export default function YaptirimListesi() {
  const { kullanici } = useContext(AuthContext);
  const navigate = useNavigate();
  const [veriler, setVeriler] = useState([]);
  const [toplam, setToplam] = useState(0);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [filtre, setFiltre] = useState({ aktif:'', yaptirim_turu:'', q:'' });

  useEffect(() => { yukle(); }, [filtre]); // eslint-disable-line

  const yukle = async () => {
    setYukleniyor(true);
    try {
      const p = new URLSearchParams({ ...filtre, limit:200 });
      const r = await api.get(`/yaptirim?${p}`);
      setVeriler(r.data.veriler||[]); setToplam(r.data.toplam||0);
    } finally { setYukleniyor(false); }
  };

  const muhurFek = async (id) => {
    if (!window.confirm('Mühür fekki yapılacak. Onaylıyor musunuz?')) return;
    try { await api.put(`/yaptirim/${id}`, { muhur_fekki:true }); yukle(); } catch(err){ alert(err.response?.data?.hata||'Hata'); }
  };

  const fmt = d => d ? new Date(d).toLocaleDateString('tr-TR') : '';
  const para = v => v ? Number(v).toLocaleString('tr-TR',{minimumFractionDigits:2})+' ₺' : '—';

  const columns = [
    { key:'unvan', label:'İşyeri', render:(v,r)=><span style={{fontSize:'12px'}}><strong>{v||'—'}</strong> <span style={{color:'#888'}}>({r.rn||'—'})</span></span>, exportValue:r=>r.unvan||'' },
    { key:'yaptirim_turu', label:'Yaptırım Türü', width:'150px', render:v=><span style={{fontSize:'11px',padding:'2px 8px',borderRadius:'10px',background:'#ffebee',color:'#c62828',fontWeight:'700'}}>{v?.replace(/_/g,' ')}</span> },
    { key:'karar_tarihi', label:'Karar Tarihi', width:'100px', render:v=><span style={{fontSize:'12px'}}>{fmt(v)}</span>, exportValue:r=>fmt(r.karar_tarihi) },
    { key:'ceza_tutari', label:'Ceza Tutarı', width:'110px', render:v=><span style={{fontSize:'13px',fontWeight:'700',color:v?'#c62828':'#bbb'}}>{para(v)}</span>, exportValue:r=>r.ceza_tutari||'' },
    { key:'muhur_no', label:'Mühür No', width:'100px', render:v=><span style={{fontSize:'12px',fontFamily:'monospace'}}>{v||'—'}</span> },
    { key:'kapatma_baslangic', label:'Kapatma Baş.', width:'110px', render:v=><span style={{fontSize:'12px',color:v?'#c62828':'#bbb'}}>{v?fmt(v):'—'}</span>, exportValue:r=>fmt(r.kapatma_baslangic) },
    { key:'kapatma_bitis', label:'Kapatma Bit.', width:'110px', render:v=><span style={{fontSize:'12px'}}>{v?fmt(v):'—'}</span>, exportValue:r=>fmt(r.kapatma_bitis) },
    { key:'aktif', label:'Durum', width:'90px', render:v=>v?<span style={{fontSize:'11px',fontWeight:'700',color:'#c62828'}}>⚠ AKTİF</span>:<span style={{fontSize:'11px',color:'#888'}}>Pasif</span> },
    { key:'_islem', label:'İşlem', width:'130px', sortable:false, filterable:false,
      render:(_,r)=>(
        <div style={{display:'flex',gap:'4px'}}>
          {['admin','mudur'].includes(kullanici?.rol)&&r.aktif&&r.muhur_no&&!r.muhur_fekki&&(
            <button className="btn btn-outline btn-xs" onClick={e=>{e.stopPropagation();muhurFek(r.id);}}>Mühür Fek</button>
          )}
          {r.ruhsat_id&&<button className="btn btn-secondary btn-xs" onClick={e=>{e.stopPropagation();navigate(`/ruhsat/${r.ruhsat_id}`);}}>Ruhsat</button>}
        </div>
      )
    },
  ];

  return (
    <div>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'20px'}}>
        <div>
          <h2 style={{color:'#1a237e',fontSize:'20px'}}>🚫 Yaptırım Kayıtları</h2>
          <div style={{fontSize:'12px',color:'#888',marginTop:'2px'}}>Dayanak: 3572 s.K. Md.6-7 / 5326 s.K. (Kabahatler K.) / 6331 s.K.</div>
        </div>
        <div style={{fontSize:'14px',fontWeight:'600',color:'#c62828'}}>{veriler.filter(v=>v.aktif).length} aktif yaptırım</div>
      </div>

      <div className="card">
        <div className="search-bar">
          <input className="search-input" placeholder="🔍 İşyeri, mühür no..." value={filtre.q} onChange={e=>setFiltre({...filtre,q:e.target.value})} />
          <select value={filtre.aktif} onChange={e=>setFiltre({...filtre,aktif:e.target.value})} style={{padding:'8px 12px',border:'1px solid #ddd',borderRadius:'4px'}}>
            <option value="">Tüm Durumlar</option>
            <option value="true">Aktif</option>
            <option value="false">Pasif</option>
          </select>
          <select value={filtre.yaptirim_turu} onChange={e=>setFiltre({...filtre,yaptirim_turu:e.target.value})} style={{padding:'8px 12px',border:'1px solid #ddd',borderRadius:'4px'}}>
            <option value="">Tüm Türler</option>
            {YAP_TURU.map(k=><option key={k} value={k}>{k.replace(/_/g,' ')}</option>)}
          </select>
        </div>
        <div style={{marginBottom:'8px',fontSize:'12px',color:'#666'}}>Toplam: <strong>{toplam}</strong> yaptırım kaydı</div>
        <DataTable columns={columns} data={veriler} filename="yaptirimlar" pdfTitle="Yaptırım Kayıtları" loading={yukleniyor} />
      </div>
    </div>
  );
}
